@let legalData = metaData()['legalData'];
@let contactData = metaData()['contactData'];

<app-navbar  [id]="'c6f25ff1-3c1e-4bcb-a903-b834d6853517'" [componentId]="'c6f25ff1-3c1e-4bcb-a903-b834d6853517'"></app-navbar>

<div class="accessibility-container">
  <h1 class="custom-title-medium">Barrierefreiheitserklärung</h1>

  <h2 class="custom-title-medium">Einleitung</h2>
  <p class="custom-body-medium">
    {{legalData.businessName}} ist bemüht, seine Website im Einklang mit den nationalen Rechtsvorschriften zur Umsetzung des Barrierefreiheitsstärkungsgesetzes (BFSG) sowie den technischen Richtlinien der WCAG 2.1 (Web Content Accessibility Guidelines) barrierefrei zugänglich zu machen.
    Diese Erklärung zur Barrierefreiheit gilt für die Website und alle unter dieser Domain veröffentlichten Inhalte von {{legalData.businessName}}.
  </p>

  <h2 class="custom-title-medium">Stand der Vereinbarkeit mit den Anforderungen</h2>
  <p class="custom-body-medium">
    Diese Website ist nach aktuellem Stand vereinbar mit den Anforderungen der WCAG 2.1 auf Konformitätsstufe AA.
    Derzeit sind keine Einschränkungen bekannt.
  </p>

  <h2 class="custom-title-medium">Nicht barrierefreie Inhalte</h2>
  <p class="custom-body-medium">
    Derzeit sind keine Inhalte bekannt, die der Barrierefreiheit gemäß den WCAG 2.1 AA nicht entsprechen. Wir arbeiten kontinuierlich daran, die Barrierefreiheit unserer Website zu verbessern und eventuelle Einschränkungen zu beheben.
  </p>

  <h2 class="custom-title-medium">Erstellung dieser Erklärung</h2>
  <p class="custom-body-medium">
    Diese Erklärung wurde am <strong>01.01.2026</strong> erstellt. Sie basiert auf einer 
    Selbstbewertung der Website.Sie wird regelmäßig überprüft und aktualisiert.
  </p>
  <p class="custom-body-medium">
    Wir überprüfen regelmäßig unsere Website auf Barrierefreiheit und aktualisieren diese Erklärung entsprechend.
  </p>

  <h2 class="custom-title-medium">Feedback und Kontakt</h2>
  <p class="custom-body-medium">
    Wir freuen uns über Ihr Feedback zur Barrierefreiheit unserer Website. Bitte kontaktieren Sie uns, 
    wenn Sie auf Barrieren stoßen oder Verbesserungsvorschläge haben:
  </p>
  <p class="custom-body-medium">
    <strong>Kontakt:</strong><br>
    {{legalData.businessName}}<br>
    {{contactData.name}}<br>
    E-Mail: {{legalData.businessContactEmail.value}}<br>
    Telefon: {{legalData.businessContactPhone.value}}
  </p>
  <p class="custom-body-medium">
    Wir bemühen uns, auf Ihr Feedback innerhalb von <strong>14 Werktagen</strong> zu antworten.
  </p>

  <h2 class="custom-title-medium">Durchsetzungsverfahren</h2>
  <p class="custom-body-medium">
    Sollten Sie innerhalb von 14 Tagen keine zufriedenstellende Antwort auf Ihre Anfrage zur Barrierefreiheit erhalten, können Sie sich an die zuständige Durchsetzungsstelle wenden: In Deutschland ist dies die Bundesfachstelle Barrierefreiheit:
  </p>
  <p class="custom-body-medium">
    <strong>Bundesfachstelle Barrierefreiheit</strong><br>
    Mauerstraße 53<br>
    10117 Berlin<br>
    E-Mail: info&#64;bundesfachstelle-barrierefreiheit.de<br>
    Telefon: +49 (0)30 12345678<br>
    Website: <a href="https://www.bundesfachstelle-barrierefreiheit.de" target="_blank" rel="noopener noreferrer">
      https://www.bundesfachstelle-barrierefreiheit.de
    </a>
  </p>
</div>
